<template>
    <div class="game-main" :style="{ height: mainHeight + 'px' }" v-loading="loading">
        <div class="game-main-content">
            <el-row>
                <game-header></game-header>
            </el-row>
            <el-row>
                <el-col v-for="index in productLevels" :key="index" :span="24" class="img-level-col">
                    <img @click="handleLevelClick(index)" class="img-level"
                        :src="require('@/assets/images/game/game-level' + (index) + '.png')">
                    <el-row style="margin: 0 auto;">
                        <el-col v-if="index === currentLevel" v-for="level in unitInfo" :key="level.unit" :span="12">
                            <el-card :class="card.cardClass[level.unit - 1]" :body-style="{ padding: '10px' }">
                                <div slot="header" class="clearfix" @click="handleClick(index - 1, level.unit)">
                                    <el-badge :value="level.unit" class="item" type="primary" style="width: 100%;">
                                        <div style="max-height: 60px;overflow: hidden;">
                                            <span>{{ level.unitName }}</span>
                                        </div>
                                    </el-badge>
                                </div>
                                <div @click="handleClick(index, level.unit)" style="width: 100%;">
                                    <el-tag size="mini">
                                        <span class="img-level-card-words">{{ level.counts }}</span>words</el-tag>
                                    <el-progress
                                        :percentage="level.percentage > 100 ? 100 : level.percentage"></el-progress>
                                </div>
                                <div v-if="level.percentage > 0">
                                    <el-tag size="mini"><span>总得分:</span><span class="img-level-card-words">{{
                                        level.score }}</span></el-tag>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row>
                <el-dialog v-loading="loading" :visible.sync="centerDialogVisible" width="100%" fullscreen
                    :center="true">
                    <div v-if="gameType === '超级消消乐'">
                        <word-temp :games="games" @load-game="getGames" @save-answer="saveAnswer"></word-temp>
                    </div>
                    <div v-else>
                        <word-input-temp :games="games" @load-game="getGames"
                            @save-answer="saveAnswer"></word-input-temp>
                    </div>
                </el-dialog>
            </el-row>
        </div>
    </div>
</template>

<script>
import api from '@/utils/api'
import Enumerable from 'linq'
import hedaer from '../../../components/game/head.vue'
import wordTemp from '../../../components/game/wordtemplete.vue'
import wordInputTemp from '../../../components/game/wordinputtemplete.vue'
export default {
    components: {
        'game-header': hedaer,
        'word-temp': wordTemp,
        'word-input-temp': wordInputTemp
    },
    data () {
        return {
            mainHeight: window.innerHeight,
            productLevels: [],
            games: [],
            centerDialogVisible: false,
            card: {
                cardClass: [],
                cardSelected: false
            },
            unitInfo: [],
            gameType: '超级消消乐',
            loading: false,
            currentUnit: 1, // 当前单元
            currentLevel: 0, // 当前级别
            currentSeries: 2 // 当前系列
        }
    },
    created () {
        this.currentSeries = this.$route.query.series || 2
        this.productLevels = this.$route.query.productLevel.split(',') ? this.$route.query.productLevel.split(',') : [0, 1, 2, 3]
        this.currentLevel = localStorage.getItem('currentLevel') || this.productLevels[0]
        this.currentUnit = localStorage.getItem('currentUnit') || 1
        this.gameType = this.$route.query.gameType || '超级消消乐'
        this.loadUnitInfo()
    },
    methods: {
        loadUnitInfo () {
            this.loading = true
            this.$axios.post(api.getSoundInfoByLevelAndUnit, { productSeries: this.currentSeries, productLevel: this.currentLevel, gameType: this.gameType })
                .then(res => {
                    this.unitInfo = res.data.result
                    for (let i = 0; i < this.unitInfo.length; i++) {
                        this.card.cardClass.push('img-level-card')
                    }
                    this.loading = false
                })
        },
        getGames () {
            var unit = Enumerable.from(this.unitInfo).where(w => w.unit === this.currentUnit).firstOrDefault()
            var percentage = 0
            if ((unit && unit.percentage >= 100)) {
                percentage = unit.percentage
                // return this.$message.warning('已完成该单元所有进度，请选择其他单元或级别进行游戏！')
            }
            this.loading = true
            this.$axios.post(api.getWordGamesData, {
                productSeries: this.currentSeries,
                productLevel: this.currentLevel,
                productUnit: this.currentUnit,
                gameType: this.gameType,
                percentage: percentage
            }).then(res => {
                if (res.data.success) {
                    this.loading = false
                    if (res.data.result.games.length === 0) {
                        return this.$message.warning('暂无游戏数据，请选择其他单元或级别进行游戏！')
                    }
                    this.games = res.data.result.games
                    this.centerDialogVisible = true
                }
            })
        },
        handleLevelClick (level) {
            // console.log('当前级别:', level)
            localStorage.setItem('currentLevel', level)
            this.currentLevel = level
        },
        handleClick (level, unit) {
            this.card.cardSelected = true
            for (let i = 0; i < this.card.cardClass.length; i++) {
                this.card.cardClass[i] = 'img-level-card'
            }
            this.card.cardClass.splice(unit - 1, 1, 'img-level-card-selected')

            this.currentUnit = unit
            this.currentLevel = level
            localStorage.setItem('currentUnit', unit)
            localStorage.setItem('currentLevel', level)
            // console.log('选择了单元：' + unit + ',级别：' + level)

            this.getGames()
        },
        saveAnswer (score) {
            // 保存答案到后台
            var unit = Enumerable.from(this.unitInfo).where(w => w.unit === this.currentUnit).firstOrDefault()
            if (!unit || (unit && unit.percentage >= 100)) {
                console.log('完成100%进度后不保存' + unit.percentage)
                return // 完成100%进度后不保存
            }
            var para = {
                productSeries: this.currentSeries,
                productLevel: this.currentLevel,
                productUnit: this.currentUnit,
                gameWords: this.games.map(m => m.word).join(','),
                score: score,
                gameType: this.gameType
            }
            this.$axios.post(api.saveScore, para)
                .then(res => {
                    this.loadUnitInfo()
                })
        }
    }
}
</script>

<style scoped lang="less">
.game-main {
    padding: 0 15px;
    background-color: #f0f9ff;
    overflow-y: scroll;
}

.game-main-content {
    background-color: #fff;
    border-radius: 6px;
    padding: 0px 15px;
    margin-top: 10px;
}

.img-level-col {
    padding: 10px;
}

.img-level-card {
    background-color: #fffde7;
    margin: 6px 3px;
    text-align: center;
    height: 150px;
}

.img-level-card-selected {
    background-color: #ffc000;
    margin: 6px 3px;
    text-align: center;
    height: 150px;
}

.img-level-col-unit {
    text-align: center;
    display: block;
}

.img-level-card-title {
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
    /* white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; */
}

.img-level-card-words {
    text-align: center;
    font-weight: 700;
    padding: 5px;
}

.img-level {
    width: 100%;
}

/* 修改整个弹窗的背景色 */
/deep/.el-dialog {
    background: #edf8ff;
}

/deep/.el-dialog--center .el-dialog__body {
    padding: 10px 5px
}
</style>



// WEBPACK FOOTER //
// src/view/game/word/index.vue